import React from 'react';
import { useFormikContext } from 'formik';
import { Form } from 'react-bootstrap';
import { parseSliderAnswer, buildSliderAnswer } from '../EvaluationScaleConfig';

const PointsScalePreview = ({ question, fieldName, sendSurvey, outOfDate }) => {
  const { setFieldValue, values } = useFormikContext();
  const disabled = !sendSurvey || outOfDate;

  const choices = question.questionChoicesAttributes || [];
  const configChoice = choices.find(c => c.kind === 'config');
  const maxValue = parseInt(configChoice?.label || '10', 10);

  const rowChoices = choices.filter(c => c.kind === 'row' && !c._destroy).sort((a, b) => a.position - b.position);

  const currentAnswerText =
    values?.employeeSurvey?.employeeQuestionChoicesAttributes?.find?.(eqc => eqc?.questionId === question.id)
      ?.answerText || '';

  const parsedSliderValues = parseSliderAnswer(currentAnswerText);

  const handleChange = (rowPosition, val) => {
    if (disabled) return;
    const updated = { ...parsedSliderValues, [rowPosition]: parseInt(val, 10) };
    setFieldValue(`${fieldName}[answerText]`, buildSliderAnswer(updated));
  };

  return (
    <div className="mt-2">
      {rowChoices.map((rowChoice, idx) => {
        const currentVal = parsedSliderValues[rowChoice.position] ?? 0;

        return (
          <div key={rowChoice.id || rowChoice.position} className="eval-points-preview-row">
            <div className="eval-points-preview-label">{rowChoice.label || `Respuesta ${idx + 1}`}</div>
            <div className="eval-points-slider-wrapper">
              <div className="eval-points-minmax">
                <span>{currentVal}</span>
                <span>{maxValue}</span>
              </div>
              <Form.Control
                type="range"
                min={0}
                max={maxValue}
                value={currentVal}
                step={1}
                disabled={disabled}
                onChange={e => handleChange(rowChoice.position, e.target.value)}
                className="eval-points-preview-slider"
              />
            </div>
            <span className="eval-points-preview-value">{currentVal}</span>
          </div>
        );
      })}
    </div>
  );
};

export default PointsScalePreview;
